import React, { Fragment } from 'react';
import locale from '../../config/locale';
import moment from 'moment';
import classNames from "classnames";
import Button from "./Button";
// @ts-ignore
import DatePicker from "react-datepicker";
import { stringToDate } from "../../utils/other";
import Label from './Label';

export const getFormat = (format?: string, showTime?: boolean, timeOnly?: boolean) => {
    return format || (timeOnly ? "HH:mm:00" : ("YYYY-MM-DD" + (showTime ? " HH:mm:00" : "")));
}

export const dateData = (value?: string|Date, showTime?: boolean, timeOnly?: boolean, format?: string) => {

    format = getFormat(format, showTime, timeOnly);

    let m = moment(value, format);
    if(m.isValid()) {
        return {
            value: m.format(format),
            dateValue: m.toDate(),
            momentValue: m,
            format: format
        }
    } else {
        return {
            value: null,
            dateValue: null,
            momentValue: m,
            format: format
        }
    }
}

const year = new Date().getFullYear();

export type DateTimeInputPropsType = {
    showTime?: boolean,
    timeOnly?: boolean,
    required?: boolean,
    value?: any,
    saveChanges?: (field: string, value: any) => void,
    name?: string,
    label?: any,
    placeholder?: string,
    selectionMode?: "single"|"multiple",
    format?: string,
    isClearable?: boolean,
    shouldCloseOnSelect?: boolean,
    error?: any,
    warning?: any,
    valid?: any,
    minDate?: Date|string,
    maxDate?: Date|string,
    focus?: boolean|string,
    autoFocus?: boolean|string,
    disabled?: true|false,
    readOnly?: true|false,
    asMoment?: boolean,
    startDate?: Date|string,
    endDate?: Date|string,
    //selectionMode?: any,
    actionsOn?: "all"|"start"|"end",
    yearRange?: string,
    initialValue?: any,
    className?: string|Record<string, any>,
}

class DateTimeInput extends React.Component<DateTimeInputPropsType> {

    static defaultProps = {
        actionsOn: "all"
    }

    input: React.RefObject<any>;


    constructor(props: DateTimeInputPropsType) {
        super(props);
        this.input = React.createRef();
    }


    onSelect = (newValue: string|Date, event: string) => {
        if (((this.props.selectionMode || "single") !== "single" && event === "change") || (this.props.selectionMode || "single") === "single") {
            if(this.props.saveChanges && newValue !== undefined) {
                let value = newValue || this.props.value || this.props.initialValue;
                if (
                    (this.props.selectionMode || "single") !== "single"
                    && Array.isArray(value)
                    &&
                    (
                        this.props.actionsOn === "all" ||
                        (this.props.actionsOn === "start" && value.length === 1) ||
                        (this.props.actionsOn === "end" && value.length === 2)
                    )
                ) {
                    value = value.map((_value) => {
                        const stateValue = this.dateData(_value);
                        if (!this.props.asMoment) {
                            _value = stateValue.value;
                        } else {
                            _value = stateValue.momentValue;
                            if (_value) {
                                _value.toFormat = function () {
                                    return _value.format(stateValue.format);
                                };
                                _value.toFormat.bind(_value);
                            }
                        }
                        return _value;
                    });
                } else {
                    let stateValue = this.dateData(value);
                    if (!this.props.value && this.props.initialValue) {
                        stateValue = this.dateData(stateValue.momentValue.format("YYYY-MM-DD ") + this.dateData(this.props.initialValue).momentValue.format("HH:mm:00"));
                    }
                    if (!this.props.asMoment) {
                        value = stateValue.value;
                    } else {
                        value = stateValue.momentValue;
                        if (value) {
                            value.toFormat = function () {
                                return value.format(stateValue.format);
                            };
                            value.toFormat.bind(value);
                        }
                    }
                }
                this.props.saveChanges(this.props.name, value);
            }
        }
    }

    dateData = (value: string|Date) => {

        let format = this.getFormat();

        let m = moment(value, format);
        if(m.isValid()) {
            return {
                value: m.format(format),
                dateValue: m.toDate(),
                momentValue: m,
                format: format
            }
        } else {
            return {
                value: null,
                dateValue: null,
                momentValue: m,
                format: format
            }
        }
    }

    getFormat = () => {
        return getFormat(this.props.format, this.props.showTime, this.props.timeOnly);
    }

    focus = () => {
        if (this.input.current) {
            this.input.current.setFocus();
        }
    }

    componentDidUpdate(prevProps: DateTimeInputPropsType) {
        const prevFocus = prevProps.focus || prevProps.autoFocus;
        const focus = this.props.focus || this.props.autoFocus;
        if (prevFocus !== focus && focus) {
            this.focus();
        }
    }

    componentDidMount() {
        if (this.props.focus || this.props.autoFocus) {
            this.focus();
        }
    }

    render() {
        const stateValue = (this.props.selectionMode || "single") !== "single" && Array.isArray(this.props.value) ? (this.props.value).map((value) => this.dateData(value).dateValue) : this.dateData(this.props.value).dateValue;
        const isClearAble = this.props.isClearable && stateValue;
        let minDate = this.props.minDate;
        minDate = typeof minDate === 'string' ? this.dateData(minDate).dateValue : minDate;
        let maxDate = this.props.maxDate;
        maxDate = typeof maxDate === 'string' ? this.dateData(maxDate).dateValue : maxDate;
        const yearRange = this.props.yearRange || ((year - 5) + ":" + (year + 5));
        if (!minDate) {
            minDate = new Date(Number(yearRange.split(":")[0]), 0, 1);
        }
        if (!maxDate) {
            maxDate = new Date(Number(yearRange.split(":")[1]), 11, 31);
        }
        const format = (this.props.timeOnly ? " HH:mm" : (this.props.showTime ? locale.dateFormat + " HH:mm" : locale.dateFormat));
        return <Fragment>
            <Label {...this.props}/>
            <div className={classNames({"input-group": isClearAble})}>
                <DatePicker
                    ref={this.input}
                    autoFocus={this.props.focus || this.props.autoFocus || false}
                    name={this.props.name}
                    autoComplete="off"
                    placeholderText={this.props.placeholder}
                    selected={stateValue}
                    onSelect={(value: string|Date) => this.onSelect(value, "change")}
                    onChange={(value: string|Date) => this.onSelect(value, "change")}
                    onChangeRaw={(event: Event) => {
                        // @ts-ignore
                        let value = event.target.value;
                        if (value) {
                            value = stringToDate(value.toLowerCase().trim());
                            if (value) {
                                this.onSelect(value, "change");
                            }
                        }
                    }}
                    timeFormat="HH:mm"
                    dateFormat={format}
                    showPopperArrow={false}
                    /*selectsStart={this.props.selectsStart}
                    selectsEnd={this.props.selectsEnd}
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}*/
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    shouldCloseOnSelect={this.props.shouldCloseOnSelect}
                    renderDayContents={(day: string/*, date: Date*/) => {
                        return <span>{day}</span>;
                    }}
                    dayClassName={(date: string|Date) => {
                        if (moment(date).isBetween(this.props.startDate, this.props.endDate)) {
                            return "react-datepicker__day--in-range";
                        }
                    }}
                    popperPlacement="bottom"
                    className={classNames(
                        "p-inputdatetime p-component form-control",
                        {"is-invalid": this.props.error, "is-warned": this.props.warning, "is-valid": this.props.valid},
                        this.props.className
                    )}
                    disabled={!!this.props.disabled}
                    minDate={minDate}
                    maxDate={maxDate}
                    timeInputLabel="Idő"
                    timeCaption="Idő"
                    showTimeInput={this.props.timeOnly ? true : this.props.showTime}
                    showTimeSelectOnly={this.props.timeOnly}
                    openToDate={stateValue ? stateValue : (this.props.initialValue ? this.dateData(this.props.initialValue).dateValue : null)}
                />
                {isClearAble && <span className="input-group-btn">
                    <Button
                        icon={{lib: "fa", name: "times"}}
                        color="default"
                        onClick={() => this.props.saveChanges(this.props.name, null)}
                        disabled={!!this.props.disabled} />
                </span>}
            </div>
            {this.props.error && <div className="invalid-feedback">{this.props.error}</div>}
            {this.props.warning && <div className="warning-feedback">{this.props.warning}</div>}
            {this.props.valid && <div className="valid-feedback">{this.props.valid}</div>}
        </Fragment>;
    }
}

export default DateTimeInput;